import { graphql } from '@guuru/graphql-common/gql';
import { CHAT_MESSAGE_FIELDS as MessageFields } from '@guuru/graphql-web';

export default graphql(
  `
    query GetChatMessages(
      $id: ID!
      $isVisibleByExpert: Boolean!
      $isVisibleByUser: Boolean!
    ) {
      chat(id: $id) {
        id
        rating
        status
        acceptedAt
        partner {
          id
          settings {
            id
            appearance {
              isUnreadMessagesEnabled
            }
          }
        }
        expert {
          id
          name
        }
        messages(
          isVisibleByExpert: $isVisibleByExpert
          isVisibleByUser: $isVisibleByUser
          orderBy: { direction: asc, field: createdAt }
        ) {
          edges {
            node {
              ...MessageFields
            }
          }
        }
      }
    }
  `,
  [MessageFields],
);
